import Service from '@ember/service';
import { load, ReCaptchaInstance } from 'recaptcha-v3';
import config from 'cio/config/environment';

export type RecaptchaAction = 'signup' | 'signup_signup';

export default class RecaptchaService extends Service {
  _recaptcha!: ReCaptchaInstance;

  async loadRecaptcha() {
    this._recaptcha = await load(config.recaptcha.siteKey);
  }

  async execute(action: RecaptchaAction) {
    // recaptcha and its siteKey are present only in production, staging envs:
    if (!config.recaptcha.siteKey) {
      return;
    }

    if (!this._recaptcha) {
      await this.loadRecaptcha();
    }

    return this._recaptcha.execute(action);
  }

  hide() {
    if (this._recaptcha) {
      this._recaptcha.hideBadge();
    }
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    recaptcha: RecaptchaService;
  }
}
